import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc CallAuthorizationFlow defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { CallAuthorizationFlowService } from 'services/callAuthorizationFlow';
 *
 * // create service instance and send/cancel request
 * const callAuthorizationFlowService = new CallAuthorizationFlowService();
 * const result = await callAuthorizationFlowService.fetchData( '<user-id>' ); // fetch data
 * callAuthorizationFlowService.cancel(); // cancel an active request
 */
export class CallAuthorizationFlowService extends HttpService {

    // make request and fetch component data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract data
            const visibility = get( response, 'body.component.visibility', {} );
            const steps = get( response, 'body.component.structure.steps', [] );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    steps: getVisibleItems( steps, visibility ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
